<template>
  <NuxtLink
    :to="localePath({ name: 'brands-slug', params: { slug: brand.slug } })"
    class="brand-item"
  >
    <div class="brand-item-cover">
      <BaseImageExternal
        v-if="brand.fileUrl"
        class="brand-cover"
        :src="brand.fileUrl"
        :alt="$t('brand.cover-alt', [brand.name])"
      />
    </div>
    <div class="brand-item-title">
      <BaseText class="card-title">{{ brand.name }}</BaseText>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { type BrandFragment } from "~/graphql/generated";

defineProps<{
  brand: BrandFragment;
}>();

const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.brand-item {
  background-color: $light-100;
  border: 1px solid $light-80;
  overflow: hidden;
  border-radius: $border-radius;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .brand-item-cover {
    flex: 1;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .brand-item-title {
    border-top: 1px solid $light-80;
    padding: 1rem;

    .card-title {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
